import { Stack, useLocalSearchParams } from 'expo-router';
import React from 'react';

import ConversationalOnboardingQABatchPage from '../../../llm-service/conversational-mm/ConversationalOnboardingQABatchPage';

export default function ConversationalOnboardingQABatchRoute() {
    const { batchId } = useLocalSearchParams<{ batchId: string }>();

    return (
        <>
            <Stack.Screen
                options={{
                    title: 'Suite Run',
                }}
            />
            <ConversationalOnboardingQABatchPage batchId={batchId} />
        </>
    );
}
